import { Chip } from "@mui/material";
import * as React from "react";
import { FieldRenderProps } from "react-final-form";
import { useTranslation } from "react-i18next";

import theme from "../styles/theme";
import { Category } from "../types";

const ExerciseSelect = ({ input }: FieldRenderProps<string[], HTMLInputElement>) => {
    const { t } = useTranslation();

    const handleOnClick = (value: string) => {
        if (input.value.includes(value)) {
            input.onChange(input.value.filter((v) => v !== value));
        } else {
            input.onChange([...input.value, value]);
        }
    };

    const getBackgroundColor = (value: Category) => (input.value.includes(value) ? theme.colors[value] : "");
    const getColor = (value: string) => (input.value.includes(value) ? theme.palette.primary.contrastText : "");

    const allCategories = (Object.values(Category) as Array<Category>).filter((x) => x !== Category.Ai);

    return (
        <div>
            {allCategories.map((category) => (
                <Chip
                    key={category}
                    style={{
                        marginRight: 8,
                        marginBottom: 8,
                        backgroundColor: getBackgroundColor(category),
                        color: getColor(category),
                    }}
                    label={t(category)}
                    onClick={() => handleOnClick(category)}
                />
            ))}
        </div>
    );
};

export default ExerciseSelect;
